module.exports = __webpack_public_path__ + "media/blog_shared_transformation_hints.551c4226.mp4";